export default __webpack_public_path__ + "static/2074-646fdbf3091ee6c842be27ca0ae40486.gif";